import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class SubRecipient_List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,
      exportLoading: false,

      permissions: [],

      sortField: 'id',
      idsortOrder: 'desc',
      provinceNamesortOrder: '',
      districtNamesortOrder: '',
      namesortOrder: '',

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value }, () => {
      if (fieldId === 'ProvinceId') {
        var TempArr = this.state.Districtlist
        var filteredArr = TempArr.filter(function (obj) {
          return obj.provinceId === value
        })
        this.setState({
          FilteredDistrictlist: filteredArr,
        })
      }
    })
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          {this.state.permissions.includes('subrecipient-update') && (
            <Link to={'/SubRecipient_Edit/' + row.id}>
              <button
                data-toggle="tooltip"
                title="Edit"
                class="btn TableRow_btn"
              >
                <i
                  class="fa fa-pencil-square-o text-primary"
                  aria-hidden="true"
                ></i>
              </button>
            </Link>
          )}
          {this.state.permissions.includes('subrecipient-delete') && (
            <button
              onClick={() => this.onDelete(row.id)}
              data-toggle="tooltip"
              title="Delete"
              class="btn TableRow_btn"
            >
              <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
            </button>
          )}
        </div>
      )
    }

    const columns = [
      {
        dataField: 'complete_name',
        text: 'Complete Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 200 };
        }
      },
      {
        dataField: 'short_name',
        text: 'Short Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 };
        }
      },
      {
        dataField: 'id',
        text: 'SR Id',
        hidden: true,
        export: true,
       
      },
      {
        dataField: 'provinceName',
        text: 'Province Name',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 };
        }
      },
    
      {
        dataField: '',
        text: 'Actions',
        headerStyle: (colum, colIndex) => {
          return { minWidth: 150 };
        },
        formatter: (cell, row) => {
          return CellMenu(cell, row)
        },
        csvExport: false,
      },
    ]

    return (
      <div>
        <AlertModal {...this.state.alertModalData} />
        <MainLayout />
        <div id="right-panel" class="right-panel">
          <Topmenu
            PageTitle="Sub Recipient"
            isShowAddBtn={this.state.permissions.includes('subrecipient-add')}
            AddBtnLabel="Add Sub-Recipient"
            AddBtnLink="/SubRecipient_Add"
          />
          <div class="content">
            <div class="card">
              <div class="card-body">
                <div class="Table_Search row">
                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <input
                      autocomplete="off"
                      type="text"
                      class="form-control Search_InputField"
                      id="SearchName"
                      placeholder="Enter Sub-Recipient name"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <button
                      style={{ position: 'relative' }}
                      onClick={() => {
                        this.PopulateTable()
                      }}
                      id="FormSearchBtn"
                      class="btn SearchTable_Btn"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <Table
                  keyField="id"
                  data={this.state.data}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  onTableChange={this.handleTableChange}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 100)
                  }}
                  exportPdf={this.ExportPdf}
                  exportAllowed={this.state.permissions.includes(
                    'subrecipient-export',
                  )}
                  isPagination={true}
                  columns={columns}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }
  componentDidMount() {
    Common.AddClassToMenueLink('MenuLink_Sr', true, 'MenuParentLink_Geography')
    this.PopulateTable()

    $('.Search_InputField').on('keypress', (e) => {
      if (e.which === 13) {
        this.PopulateTable()
      }
    })

    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_RolesPermissions,
      {
        pageSize: 15,
        pageNumber: 1,
      },
      (resp) => {
        const modifiedPermissions = resp.data
          .filter(
            (p) =>
              p.permissioN_GROUP === 'SubRecipient' && p.permissioN_ALLOWED,
          )
          .map((d) => d.permissioN_NAME)
        this.setState({ permissions: modifiedPermissions })
      },
    )
  }
  handleTableChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
  ) => {
    if (type === 'sort') {
      let tempFieldorderLabel = sortField + 'sortOrder'
      let tempFieldorder =
        this.state[tempFieldorderLabel] === ''
          ? sortOrder
          : this.state[tempFieldorderLabel] === 'asc'
          ? 'desc'
          : 'asc'
      this.setState(
        {
          sortField,
          [tempFieldorderLabel]: tempFieldorder,
        },
        () => {
          this.PopulateTable()
        },
      )
      return
      // let result = this.state.data
      // // Handle column sort
      // if (sortOrder === 'asc') {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return 1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return -1;
      //     }
      //     return 0;
      //     });
      // } else {
      //     result = result.sort((a, b) => {
      //     if (a[sortField] > b[sortField]) {
      //         return -1;
      //     } else if (b[sortField] > a[sortField]) {
      //         return 1;
      //     }
      //     return 0;
      //     });
      // }
      // return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }
  ExportPdf = () => {
    const doc = new jsPDF()

    doc.autoTable({
      theme: 'grid',
      body: [...this.state.data],
      columns: [
        { header: 'id', dataKey: 'id' },
        { header: 'Complete Name', dataKey: 'complete_name' },
        { header: 'Short Name', dataKey: 'short_name' },
        { header: 'Province Name', dataKey: 'provinceName' },
        { header: 'District Name', dataKey: 'districtName' },
      ],
    })

    doc.save('recipient.pdf')
  }
  ExportData = (size) => {
    var Parameters = {
      pageSize: size,
      pageNumber: 1,
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        if (resp.status) {
          this.setState({
            data: resp.data,
            TotalRecord: resp.totalRecord,
            exportLoading: false,
          })
          $('.react-bs-table-csv-btn').click()
          this.PopulateTable()
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  PopulateTable = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectALl_SubRecipient,
      {
        isPaginate: true,
        pageSize: this.state.sizePerPage,
        pageNumber: this.state.page,
      },
      (resp) => {
        let data = resp.data
        // Sort
        if (this.state[this.state.sortField + 'sortOrder'] === 'asc') {
          data = data.sort((a, b) => {
            if (a[this.state.sortField] > b[this.state.sortField]) {
              return 1
            } else if (b[this.state.sortField] > a[this.state.sortField]) {
              return -1
            }
            return 0
          })
        } else {
          data = data.sort((a, b) => {
            if (a[this.state.sortField] > b[this.state.sortField]) {
              return -1
            } else if (b[this.state.sortField] > a[this.state.sortField]) {
              return 1
            }
            return 0
          })
        }

        // Paginate
        var paginatedData = Common.paginate(
          data,
          this.state.sizePerPage,
          this.state.page,
        )

        $('#FormSearchBtn').prop('disabled', false)
        this.setState({
          data: paginatedData,
          TotalRecord: resp.totalRecord,
          loading: false,
        })
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  onDelete = (id) => {
    this.setState(
      {
        alertModalData: {
          title: 'Delete Sub Recipient',
          message: 'Are you sure you want to delete this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  DeleteRecord = (id) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_SubRecipient,
      { id: id },
      (Result) => {
        if (Result.status) {
          SyncConfig(
            () => {
              this.PopulateTable()
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({ Type: 1, Msg: 'Deleted Successfully.' })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
            () => {
              this.props.ShowLoader({ Isloading: false })
              this.props.ShowAlert({
                Type: 0,
                Msg: 'Error in sync, please reload the page',
              })
              setTimeout(function () {
                $('#Alertmsgbtn').click()
              }, 50)
            },
          )
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubRecipient_List)
